import { Car, Plane, Sailboat, Ship, UtensilsCrossed } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = [Car, Plane, Sailboat, Ship, UtensilsCrossed];
const FLYER = "/photos/servizi_volantino.jpg";

export default function Services() {
  const { t } = useLang();
  return (
    <section id="servizi" className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36" data-testid="services-section">
      <div className="mb-14 md:mb-20">
        <Reveal>
          <Eyebrow>{t.services.eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 max-w-3xl font-serif text-4xl font-light leading-[1.05] md:text-6xl">
            {t.services.title}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 max-w-xl text-base text-ink2">{t.services.sub}</p>
        </Reveal>
      </div>

      <div className="grid gap-12 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-7">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.t} delay={0.06 * i}>
                <div
                  className="group flex items-start gap-5 border-b border-line py-6 transition-colors duration-300 hover:bg-ink/[0.03] md:py-7"
                  data-testid={`services-item-${i}`}
                >
                  <span className="pt-1.5 text-xs tracking-[0.2em] text-ink2">0{i + 1}</span>
                  <Icon className="h-6 w-6 shrink-0 text-terra transition-transform duration-300 group-hover:-translate-y-0.5" />
                  <div>
                    <h3 className="font-serif text-xl md:text-2xl">{s.t}</h3>
                    <p className="mt-1 text-sm text-ink2 md:text-[15px]">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.3}>
            <p className="mt-7 text-sm italic text-ink2">{t.services.note}</p>
          </Reveal>
        </div>

        <Reveal className="md:col-span-5" delay={0.15}>
          <div className="group relative mx-auto max-w-sm md:sticky md:top-28 md:max-w-none">
            <div
              className="rotate-2 rounded-lg border border-line bg-white p-3 shadow-[0_24px_60px_-24px_rgba(0,0,0,0.35)] transition-transform duration-500 group-hover:rotate-0"
              data-testid="services-flyer-card"
            >
              <img
                src={FLYER}
                alt="Volantino servizi esclusivi Private Oasis Villa"
                loading="lazy"
                className="w-full rounded-[4px]"
                data-testid="services-flyer-image"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
